<template>
    <component :is="activeComponent" />
</template>

<script>

import { onClientReady, featureFlags } from "@/scripts/FeatureFlags";
import OnlineTestsList from "./OnlineTestsList.vue";
import OnlineTestsListNew from "./OnlineTestsListNew.vue";

export default {
    name: 'OnlineTestsWrapper',
    components: {
        OnlineTestsList,
        OnlineTestsListNew
    },
    data() {
        return {
            flagsReady: false,
            useNewLayout: false
        };
    },
    computed: {
        activeComponent() {
            if (!this.flagsReady) {
                return 'OnlineTestsList';
            }
            return this.useNewLayout ? 'OnlineTestsListNew' : 'OnlineTestsList';
        }
    },
    created() {
        onClientReady(() => {
            this.useNewLayout = featureFlags['new_online_test_list'];
            this.flagsReady = true;
        });
    }
}
</script>
